import React, { useState, useEffect} from "react";
import { useIntl, FormattedMessage } from 'react-intl'
import {
	Collapse,
	TextField,
	Grid,
	Box,
	CircularProgress
} from '@material-ui/core';
import Switch from "react-switch";
import * as Utils from '../../commons/utils/Utils';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import { makeStyles } from '@material-ui/core/styles';
import GravatarOption from '../ui/GravatarOption'
import * as PERIODO_FILTROS from '../../commons/constants/periodoFiltros.js'
import moment, { updateLocale } from 'moment'

const FILTER_STATE_INIT = {
	centroCosto: null,
	estado: null,
	TipoFormulario: '',
	entidad: '',
	periodoInicio: null,
	periodoFin: null,
	dashboard: '',
	showInactivos: false,
	transportadora: null,
	periodo: null
}

const handleInitFilters = (intl) => {
	let filterInit = JSON.parse(JSON.stringify(FILTER_STATE_INIT))
	filterInit.periodo = { id: PERIODO_FILTROS.PERIODO_TODO_ID, label: intl.formatMessage({ id: 'periodos.todo', defaultMessage: 'Todo' })};
	let storage = JSON.parse(window.localStorage.getItem('FormularioRecurrenciaGridFilter'))
	if(storage && storage.activo && storage.filtros){
		filterInit = storage.filtros
	}
	return filterInit
}

const useStyles = makeStyles((theme)=>({
	root: {
		fontSize: '1rem',
		fontWeight: '400',
		fontFamily: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
		color: "#6B6F82",
		borderBottom: "1px solid #e3ebf3 !important"
	}
}));

const FormularioRecurrenciaGridFilters = (props) => {
	const intl = useIntl();
	const [init,setInit] = useState(false)
	const [filtersLoading, setFiltersLoading] = useState(false)
	const [filtersState, setFiltersState] = useState(handleInitFilters(useIntl()));
	const [centroCostos, setCentroCostos] = useState([]);
	const estados = [
		{ value: 1, label: intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.estado.vigente", defaultMessage: "Vigente" }) },
		{ value: 2, label: intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.estado.vencido", defaultMessage: "Vencido" }) }
	];
	const classes = useStyles();
	const periodos = [
      { id: PERIODO_FILTROS.PERIODO_HOY_ID, label: intl.formatMessage({ id: 'periodos.hoy', defaultMessage: 'Hoy' })},
      { id: PERIODO_FILTROS.PERIODO_AYER_ID, label: intl.formatMessage({ id: 'periodos.ayer', defaultMessage: 'Ayer' })},
      { id: PERIODO_FILTROS.PERIODO_ULTIMOS_SIETE_DIAS_ID, label: intl.formatMessage({ id: 'periodos.ultimos_siete_dias', defaultMessage: 'Últimos 7 días' })},
      { id: PERIODO_FILTROS.PERIODO_ULTIMOS_CATORCE_DIAS_ID, label: intl.formatMessage({ id: 'periodos.ultimos_catorce_dias', defaultMessage: 'Últimos 14 días' })},
      { id: PERIODO_FILTROS.PERIODO_ULTIMOS_TREINTA_DIAS_ID, label: intl.formatMessage({ id: 'periodos.ultimos_treinta_dias', defaultMessage: 'Últimos 30 días' })},
      { id: PERIODO_FILTROS.PERIODO_MES_ACTUAL_ID, label: intl.formatMessage({ id: 'periodos.ultimo_mes', defaultMessage: 'Este mes' })},
      { id: PERIODO_FILTROS.PERIODO_MES_PASADO_ID, label: intl.formatMessage({ id: 'periodos.mes_pasados', defaultMessage: 'Mes Pasado' })},
      { id: PERIODO_FILTROS.PERIODO_ESTE_ANIO_ID, label: intl.formatMessage({ id: 'periodos.este_anio', defaultMessage: 'Este año' })},
      { id: PERIODO_FILTROS.PERIODO_ANIO_PASADO_ID, label: intl.formatMessage({ id: 'periodos.anio_pasado', defaultMessage: 'Año Pasado' })},
      { id: PERIODO_FILTROS.PERIODO_TODO_ID, label: intl.formatMessage({ id: 'periodos.todo', defaultMessage: 'Todo' })},
	  { id: PERIODO_FILTROS.PERIODO_PERSONALIZADO_ID, label: intl.formatMessage({ id: 'periodos.personalizado', defaultMessage: 'Personalizado' })}
	];
	const [transportadoras, setTransportadoras] = useState([]);
	useEffect(() => {
		fetchData()
		initFilter()
	}, []);

	useEffect(() => {
		if(props.resetFilterInputs){
			let filterStateInit = JSON.parse(JSON.stringify(FILTER_STATE_INIT));
			filterStateInit.periodo = { id: PERIODO_FILTROS.PERIODO_TODO_ID, label: intl.formatMessage({ id: 'periodos.todo', defaultMessage: 'Todo' })};
			setFiltersState(filterStateInit);
			window.localStorage.setItem('FormularioRecurrenciaGridFilter',JSON.stringify({activo: false, filtros: filterStateInit}));
		}
	},[props.resetFilterInputs])
	
	useEffect(() => {
		!props.dropdownActive && props.setFilterResetInputs(false)
		!props.dropdownActive && setFiltersLoading(false)
	}, [props.dropdownActive]);

	const validator = () => {
		var result = Object.entries(filtersState);
		for (var index in result){
			if(result[index][1]){
				return false
			}
		}
		return true
	}

	const initFilter = () => {
		setFiltersLoading(true);

		if(props.persisteFiltros){
			props.setSearchActive(true);
		}

		let query = queryTable();
		setInit(true)
		window.localStorage.setItem('FormularioRecurrenciaGridFilter',JSON.stringify({activo: props.persisteFiltros, filtros: filtersState}));
		props.setFilterQuery(query);
		return;
	}

	const fetchData = () => {
		setFiltersLoading(true)
		Promise.all([
			Utils.getData('/centros-costos/select'),
			Utils.getData('/transportadoras/select')
		]).then((data) => {
			setCentroCostos(data[0] ? data[0] : [])
			setTransportadoras(data[1] ? data[1] : [])
		}).catch((err) => {
			setFiltersLoading(false)
		})
		
	}

	const handleChange = (name, object) => {
		setFiltersState((prevState) => {
			const updatedFiltersState = { ...prevState, [name]: object };                
			if (props.persisteFiltros) {
				window.localStorage.setItem(
					'FormularioRecurrenciaGridFilter',
					JSON.stringify({
						activo: props.persisteFiltros,
						filtros: updatedFiltersState
					})
				);                    
			}
			return updatedFiltersState;
		});      
	};

	const handleSelectPeriodoChange = (object) => {
		let inicio = "";
		let fin = "";
		if (object && object.id !== PERIODO_FILTROS.PERIODO_PERSONALIZADO_ID) {
		
			switch (object.id) {
				case PERIODO_FILTROS.PERIODO_HOY_ID:
					inicio = moment().format('YYYY-MM-DD');
					fin = moment().format('YYYY-MM-DD');
					break;
				case PERIODO_FILTROS.PERIODO_AYER_ID:
					inicio = moment().subtract(1, 'days').format('YYYY-MM-DD');
					fin = inicio;
					break;
				case PERIODO_FILTROS.PERIODO_ULTIMOS_SIETE_DIAS_ID:
					inicio = moment().subtract(7, 'days').format('YYYY-MM-DD');
					fin = moment().format('YYYY-MM-DD');
					break;
				case PERIODO_FILTROS.PERIODO_ULTIMOS_CATORCE_DIAS_ID:
					inicio = moment().subtract(14, 'days').format('YYYY-MM-DD');
					fin = moment().format('YYYY-MM-DD');
					break;
				case PERIODO_FILTROS.PERIODO_ULTIMOS_TREINTA_DIAS_ID:
					inicio = moment().subtract(30, 'days').format('YYYY-MM-DD');
					fin = moment().format('YYYY-MM-DD');
					break;
				case PERIODO_FILTROS.PERIODO_MES_ACTUAL_ID:
					inicio = moment().startOf('month').format('YYYY-MM-DD');
					fin = moment().format('YYYY-MM-DD');
					break;
				case PERIODO_FILTROS.PERIODO_MES_PASADO_ID:
					inicio = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
					fin = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
					break;
				case PERIODO_FILTROS.PERIODO_ANIO_PASADO_ID:
					inicio = moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
					fin = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
					break;
				case PERIODO_FILTROS.PERIODO_TODO_ID:
					inicio = null;
					fin = null;
					break;
				default:
					inicio = null;
					fin = null;
			}

		} else if (object.inicio) {
			inicio = moment(object.inicio).format('YYYY-MM-DD');
			fin = moment(object.fin).format('YYYY-MM-DD');
		}
		setFiltersState((prevState) => {
			const updatedFiltersState = { ...prevState, periodoInicio: inicio, periodoFin: fin, periodo: object };                
			if (props.persisteFiltros) {
				window.localStorage.setItem(
					'FormularioRecurrenciaGridFilter',
					JSON.stringify({
						activo: props.persisteFiltros,
						filtros: updatedFiltersState
					})
				);                    
			}
			return updatedFiltersState; // Retornar el nuevo estado
		});    
	}

	const handleChangeInactivosSwich = (value) => {
		setFiltersState({...filtersState, showInactivos : value});
	};

	const queryTable = () => {
		let query = {}
		query = JSON.parse(JSON.stringify(filtersState));
    	query['centroCosto'] = filtersState.centroCosto ? filtersState.centroCosto.value : ''
		query['estado'] = filtersState.estado ? filtersState.estado.value : ''
		query['tipoFormulario'] = filtersState.tipoFormulario ? filtersState.tipoFormulario : ''
		query['entidad'] = filtersState.entidad ? filtersState.entidad : ''
		query['periodoInicio'] = filtersState.periodoInicio ? filtersState.periodoInicio : ''
		query['periodoFin'] = filtersState.periodoFin ? filtersState.periodoFin : ''
		query['transportadora'] = filtersState.transportadora ? filtersState.transportadora.map(e => e.id).join(',') : ''
		return query;
	}

	const handleSubmitInto = (event) => {
		if(!props.loading){
			handleSubmit(event);
		}
		event.preventDefault();
	}

	const onChangePersistentFilter = (value) => {
		window.localStorage.setItem('FormularioRecurrenciaGridFilter', JSON.stringify({activo: value, filtros: filtersState}));
		props.setPersisteFiltros(value)
	}

	const handleSubmit = (event) => {
		props.handleFilterChange();
		event.preventDefault();
		props.setSearchActive(!validator())
		let query = queryTable();
		props.setFilterQuery(query);
		props.setResetFilterInputs(false);
		return;
	}

	return (
		<>
			{init &&
				<Collapse in={props.dropdownActive}>
					<Grid container item xs={12} spacing={3} style={{marginBottom:20}}>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.tipo_formulario", defaultMessage: "Tipo de Formulario" })}
									placeholder={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.tipo_formulario", defaultMessage: "Tipo de Formulario" })}
									name="tipoFormulario"
									value={filtersState.tipoFormulario}
									onChange={(e) => setFiltersState({...filtersState, tipoFormulario: e.target.value})}
									disabled={filtersLoading}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.entidad", defaultMessage: "Entidad" })}
									placeholder={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.entidad", defaultMessage: "Entidad" })}
									name="entidad"
									value={filtersState.entidad}
									onChange={(e) => setFiltersState({...filtersState, entidad: e.target.value})}
									disabled={filtersLoading}
									className="col-12"
								/>
							</form>
						</Grid>
						{/*PERIODO */}
						<Grid component={Box} item xs={3}>
							<form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Select
									id="periodo"
									name="periodo"
									clearable={false}
									options={periodos}
									optionComponent={GravatarOption}
									valueKey="id"
									labelKey="label"
									className="select-periodo-filter"
									value={filtersState.periodo ? filtersState.periodo : null}
									onChange={(e) => handleSelectPeriodoChange(e)}
								/>
							</form>
						</Grid>
            			<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Autocomplete
									size="small"
									name="estado"
									disabled={filtersLoading}
									options={estados}
									value={filtersState.estado}
									defaultValue={null}
									getOptionLabel={(option) => option ? option.label : ""}
									onChange={(e, value) => handleChange('estado', value)}
									renderInput={(params) => (
										<TextField {...params} variant="standard"
											label={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.estado", defaultMessage: "Estado" })}
											placeholder={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.estado", defaultMessage: "Estado" })}
											InputProps={{
												...params.InputProps,
												endAdornment: (
													<React.Fragment>
														{filtersLoading ? (
															<CircularProgress color="inherit" size={21} />
														) : null}
														{params.InputProps.endAdornment}
													</React.Fragment>
												),
											}}
										/>
									)}
								/>

							</form>
						</Grid>
            			<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Autocomplete
									size="small"
									name="centroCosto"
									disabled={filtersLoading}
									options={centroCostos}
									value={filtersState.centroCosto}
									defaultValue={null}
									getOptionLabel={(option) => option ? option.label : ""}
									onChange={(e, value) => handleChange('centroCosto', value)}
									renderInput={(params) => (
										<TextField {...params} variant="standard"
											label={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.Centro_de_Costo", defaultMessage: "Centro de Costo" })}
											placeholder={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.Centro_de_Costo", defaultMessage: "Centro de Costo" })}
											InputProps={{
												...params.InputProps,
												endAdornment: (
													<React.Fragment>
														{filtersLoading ? (
															<CircularProgress color="inherit" size={21} />
														) : null}
														{params.InputProps.endAdornment}
													</React.Fragment>
												),
											}}
										/>
									)}
								/>
							</form>
						</Grid>
						<Grid {...(!props.columnsEnabled.transportadora && { display: 'none' })} component={Box} item xs={3} >
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Autocomplete
									size="small"
									name="transportadora"
									multiple={true}
									disabled={filtersLoading}
									options={transportadoras}
									value={filtersState.transportadora ? filtersState.transportadora : []}
									defaultValue={[]}
									getOptionLabel={(option) => option ? option.nombre : ""}
									onChange={(e, value) => {
										setFiltersState({ ...filtersState, transportadora: value });
										handleChange('transportadora', value);
									}}
									renderInput={(params) => (
										<TextField {...params} variant="standard"
											label={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.Transportadora", defaultMessage: "Transportadora" })}
											placeholder={intl.formatMessage({ id: "FormularioRecurrenciaGridFilters.Transportadora", defaultMessage: "Transportadora" })}
											InputProps={{
												...params.InputProps,
												endAdornment: (
													<React.Fragment>
														{filtersLoading ? (
															<CircularProgress color="inherit" size={21} />
														) : null}
														{params.InputProps.endAdornment}
													</React.Fragment>
												),
											}}
										/>
									)}
								/>
								
							</form>
						</Grid>
						<Grid
							xs={12}
							container
							justifyContent="space-between"
							alignItems="center"
							flexDirection={{ xs: 'column', sm: 'row' }}
							sx={{ fontSize: '12px' }}
						>
							<Grid component={Box} item xs={2} className="align-self-end mx-1">
								<div className="d-flex inline justify-content-around align-items-center">
									<FormattedMessage
										id="formulariosGridFilters.render.filtros.ver_inactivos"
										defaultMessage="Ver Inactivos"
									/>
									<Switch
										onChange={(value) => handleChangeInactivosSwich(value)}
										checked={filtersState.showInactivos}
										disabled={filtersLoading}
										offColor="#FF4961"
										onColor="#28D094"
									/>
								</div>
							</Grid>
							<Grid component={Box} item xs={2} className="align-self-end">
								<div className="d-flex inline justify-content-around align-items-center">
									<FormattedMessage
										id="formulariosGridFilters.render.filtros.persistir_filtros"
										defaultMessage="Persistir Filtros"
									/>
									<Switch
										onChange={(value) => onChangePersistentFilter(value)}
										checked={props.persisteFiltros}
										disabled={filtersLoading}
										offColor="#FF4961"
										onColor="#28D094"
									/>
								</div>
							</Grid>
							<Grid component={Box} item xs={1} className="align-self-end">
								<button
									disabled={props.loading}
									className="btn btn-primary mr-1"
									onClick={(e) => handleSubmit(e)}
								>
									<i className="fa fa-search fa-xs"></i>   <FormattedMessage id="Buscar" defaultMessage="Buscar"/>
								</button>
							</Grid>
						</Grid>
					</Grid>
				</Collapse>
			}
		</>
	)
}

export default FormularioRecurrenciaGridFilters
